// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.dungeon-loot-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  z-index: 9999;
}

.dungeon-loot-shell {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  position: relative;
  width: 760px;
  max-width: 94%;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
}
.dungeon-loot-shell * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .dungeon-loot-shell {
    animation: none;
  }
}

.dungeon-loot-header {
  margin-bottom: 14px;
}
.dungeon-loot-header__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.dungeon-loot-header__text {
  flex: 1;
  min-width: 0;
}
.dungeon-loot-header__brand {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.dungeon-loot-header__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 2px 0 0;
}
.dungeon-loot-header__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  flex: none;
  padding: 2px 10px;
  font-size: 20px;
  line-height: 1.2;
}
.dungeon-loot-header__close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.dungeon-loot-header__close:active:not(:disabled) {
  transform: translateY(1px);
}
.dungeon-loot-header__close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.dungeon-loot-header__close:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.dungeon-loot-header__close:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.dungeon-loot-header__subtitle {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  margin-top: 8px;
}
.dungeon-loot-header__subtitle--warn {
  color: var(--gold-light);
}

.dungeon-loot-body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}

.dungeon-loot-table-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  padding-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #8d8a82;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.dungeon-loot-table-head__cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dungeon-loot-table-head__cell--label {
  flex: 1.6;
}
.dungeon-loot-table-head__cell--baseid {
  flex: 1.2;
}
.dungeon-loot-table-head__cell--num {
  flex: 0.8;
  min-width: 0;
}
.dungeon-loot-table-head__cell--del {
  flex: none;
  width: 28px;
}

.dungeon-loot-list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  max-height: 320px;
}
.dungeon-loot-list::-webkit-scrollbar {
  width: 6px;
}
.dungeon-loot-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.dungeon-loot-row-wrap {
  position: relative;
}

.dungeon-loot-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}
.dungeon-loot-row__cell--label {
  flex: 1.6;
}
.dungeon-loot-row__cell--baseid {
  flex: 1.2;
}
.dungeon-loot-row__cell--num {
  flex: 0.8;
  min-width: 0;
}
.dungeon-loot-row__cell--del {
  flex: none;
  width: 28px;
}

.dungeon-loot-input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  padding: 6px 9px;
}
.dungeon-loot-input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.dungeon-loot-input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}

.dungeon-loot-empty {
  padding: 18px 0;
  font-size: 14px;
  color: #8d8a82;
}

.dungeon-loot-row-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 4px 0;
  font-size: 18px;
  line-height: 1;
}
.dungeon-loot-row-remove:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.dungeon-loot-row-remove:active:not(:disabled) {
  transform: translateY(1px);
}
.dungeon-loot-row-remove:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.dungeon-loot-row-remove:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.dungeon-loot-row-remove:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.dungeon-loot-row-remove:hover:not(:disabled) {
  color: #d9786d;
}

.dungeon-loot-suggestions {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  max-height: 220px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
  z-index: 10000;
}
.dungeon-loot-suggestions::-webkit-scrollbar {
  width: 6px;
}
.dungeon-loot-suggestions::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.dungeon-loot-suggestion {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 7px 10px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-align: left;
  color: #ebe8e1;
  background: none;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
}
.dungeon-loot-suggestion:last-child {
  border-bottom: 0;
}
.dungeon-loot-suggestion:hover, .dungeon-loot-suggestion:focus-visible {
  background: rgba(255, 255, 255, 0.08);
  outline: none;
}
.dungeon-loot-suggestion__name {
  font-size: 14px;
}
.dungeon-loot-suggestion__meta {
  font-size: 13px;
  color: #8d8a82;
}

.dungeon-loot-add-btn {
  margin-top: 10px;
  align-self: flex-start;
}

.dungeon-loot-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.dungeon-loot-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.dungeon-loot-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.dungeon-loot-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.dungeon-loot-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.dungeon-loot-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.dungeon-loot-btn--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.dungeon-loot-btn--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.dungeon-loot-btn--secondary { /* neutral, same as the base button */ }`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/DungeonLootConfig/DungeonLootConfig.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDcU;ECbV,aAAA;AAMF;;AAHA;EDaE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECvJA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAYF;ADPE;EAAI,sBAAA;ACUN;ADmIE;EC5JF;ID4J4C,eAAA;EC/H1C;AACF;;AAjBA;EACE,mBAAA;AAoBF;AAlBE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAoBJ;AAjBE;EACE,OAAA;EACA,YAAA;AAmBJ;AAhBE;EDwBA,eAAA;EACA,gBAAA;EACA,cAlDO;AC6CT;AAjBE;EDKA,kDA3BW;EA4BX,gBAAA;EACA,eCNqB;EDOrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECgCH,eAAA;AAwBJ;AArBE;ED4BA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;ECnEE,UAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAwCJ;ADDE;EAAyB,qCAAA;EAAuC,8BAAA;ACKlE;ADJE;EAA0B,0BAAA;ACO5B;ADNE;EAAa,YAAA;EAAc,mBAAA;ACU7B;ADTE;EAAkB,oCAAA;EAAsC,mBAAA;ACa1D;ADWE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACNhF;AAzDE;EDAA,eAAA;EACA,gBAAA;EACA,cA7CO;EC6CL,eAAA;AA6DJ;AA3DI;EAAU,wBAAA;AA8Dd;;AA1DA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,OAAA;AA6DF;;AA1DA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDjEO;ECkEP,kDAAA;AA6DF;AA3DE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA6DJ;AA3DI;EAAW,SAAA;AA8Df;AA7DI;EAAY,SAAA;AAgEhB;AA/DI;EAAS,SAAA;EAAW,YAAA;AAmExB;AAlEI;EAAS,UAAA;EAAY,WAAA;AAsEzB;;AAlEA;ED8DE,gBAAA;EACA,qBAAA;EACA,qDAAA;EC9DA,iBAAA;AAuEF;ADPE;EAAuB,UAAA;ACUzB;ADTE;EAA6B,oCAAA;EAAsC,kBAAA;ACarE;;AA3EA;EACE,kBAAA;AA8EF;;AA3EA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA8EF;AA3EI;EAAW,SAAA;AA8Ef;AA7EI;EAAY,SAAA;AAgFhB;AA/EI;EAAS,SAAA;EAAW,YAAA;AAmFxB;AAlFI;EAAS,UAAA;EAAY,WAAA;AAsFzB;;AAlFA;EDWE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECjBA,gBAAA;AA6FF;AD1EE;EAAU,aAAA;EAAe,8BAAA;AC8E3B;AD7EE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACoF1G;;AArGA;EACE,eAAA;EACA,eAAA;EACA,cD/GO;ACuNT;;AArGA;EDrDE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;ECcA,cAAA;EACA,eAAA;EACA,cAAA;AAyHF;ADlKE;EAAyB,qCAAA;EAAuC,8BAAA;ACsKlE;ADrKE;EAA0B,0BAAA;ACwK5B;ADvKE;EAAa,YAAA;EAAc,mBAAA;AC2K7B;AD1KE;EAAkB,oCAAA;EAAsC,mBAAA;AC8K1D;ADtJE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC2JhF;AA3IE;EAAyB,cDxHlB;ACsQT;;AAvIA;EDcE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECdA,iBAAA;EACA,yDD5HU;EC6HV,kCD3II;EC4IJ,0CAAA;EACA,kBDnIO;ECoIP,yCAAA;EACA,cAAA;AA4IF;ADlIE;EAAuB,UAAA;ACqIzB;ADpIE;EAA6B,oCAAA;EAAsC,kBAAA;ACwIrE;;AAhJA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,yDDzIU;EC0IV,gBAAA;EACA,cDpJK;ECqJL,gBAAA;EACA,SAAA;EACA,kDAAA;EACA,eAAA;AAmJF;AAjJE;EAAe,gBAAA;AAoJjB;AAnJE;EAA2B,qCAAA;EAAuC,aAAA;AAuJpE;AArJE;EAAU,eAAA;AAwJZ;AAtJE;EACE,eAAA;EACA,cD/JK;ACuTT;;AApJA;EACE,gBAAA;EACA,sBAAA;AAuJF;;AApJA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;AAuJF;;AApJA;EDpHE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;AC4QF;AD1QE;EAAyB,qCAAA;EAAuC,8BAAA;AC8QlE;AD7QE;EAA0B,0BAAA;ACgR5B;AD/QE;EAAa,YAAA;EAAc,mBAAA;ACmR7B;ADlRE;EAAkB,oCAAA;EAAsC,mBAAA;ACsR1D;AAnLE;ED/FA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;ACqRF;ADnRE;EAAyB,6BAAA;EAA+B,+BAAA;ACuR1D;AA3LE,+BAAA,qCAAA,EAAA","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Dungeon chest loot table editor: centred ink window with an editable table.\n// Primary action: save (footer). Everything else is neutral or quiet.\n\n.dungeon-loot-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(2, 3, 8, 0.6);\n  pointer-events: none;\n  font-family: ink.$font-text;\n  z-index: 9999;\n}\n\n.dungeon-loot-shell {\n  @include ink.panel;\n  @include ink.enter;\n  pointer-events: auto;\n  position: relative;\n  width: 760px;\n  max-width: 94%;\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 24px;\n}\n\n.dungeon-loot-header {\n  margin-bottom: 14px;\n\n  &__row {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  &__text {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__brand {\n    @include ink.hint;\n  }\n\n  &__title {\n    @include ink.title(22px);\n    margin: 2px 0 0;\n  }\n\n  &__close {\n    @include ink.button;\n    @include ink.button-quiet;\n    flex: none;\n    padding: 2px 10px;\n    font-size: 20px;\n    line-height: 1.2;\n  }\n\n  &__subtitle {\n    @include ink.lead;\n    margin-top: 8px;\n\n    &--warn { color: var(--gold-light); }\n  }\n}\n\n.dungeon-loot-body {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1;\n}\n\n.dungeon-loot-table-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n  padding-bottom: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: ink.$text-3;\n  border-bottom: 1px solid ink.$line;\n\n  &__cell {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &--label { flex: 1.6; }\n    &--baseid { flex: 1.2; }\n    &--num { flex: 0.8; min-width: 0; }\n    &--del { flex: none; width: 28px; }\n  }\n}\n\n.dungeon-loot-list {\n  @include ink.scroll;\n  max-height: 320px;\n}\n\n.dungeon-loot-row-wrap {\n  position: relative;\n}\n\n.dungeon-loot-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 0;\n\n  &__cell {\n    &--label { flex: 1.6; }\n    &--baseid { flex: 1.2; }\n    &--num { flex: 0.8; min-width: 0; }\n    &--del { flex: none; width: 28px; }\n  }\n}\n\n.dungeon-loot-input {\n  @include ink.field;\n  padding: 6px 9px;\n}\n\n.dungeon-loot-empty {\n  padding: 18px 0;\n  font-size: 14px;\n  color: ink.$text-3;\n}\n\n.dungeon-loot-row-remove {\n  @include ink.button;\n  @include ink.button-quiet;\n  padding: 4px 0;\n  font-size: 18px;\n  line-height: 1;\n\n  &:hover:not(:disabled) { color: ink.$danger; }\n}\n\n// Rendered via a portal into document.body (see index.tsx) so it floats\n// above everything instead of being clipped by dungeon-loot-list's\n// overflow-y:auto - position/top/left/width come from an inline style\n// computed from the input's own bounding rect, this only supplies the look.\n.dungeon-loot-suggestions {\n  @include ink.scroll;\n  max-height: 220px;\n  font-family: ink.$font-text;\n  background: ink.$ink;\n  border: 1px solid ink.$line-strong;\n  border-radius: ink.$radius;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);\n  z-index: 10000;\n}\n\n.dungeon-loot-suggestion {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 7px 10px;\n  font-family: ink.$font-text;\n  text-align: left;\n  color: ink.$text;\n  background: none;\n  border: 0;\n  border-bottom: 1px solid ink.$line;\n  cursor: pointer;\n\n  &:last-child { border-bottom: 0; }\n  &:hover, &:focus-visible { background: rgba(255, 255, 255, 0.08); outline: none; }\n\n  &__name { font-size: 14px; }\n\n  &__meta {\n    font-size: 13px;\n    color: ink.$text-3;\n  }\n}\n\n.dungeon-loot-add-btn {\n  margin-top: 10px;\n  align-self: flex-start;\n}\n\n.dungeon-loot-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px solid ink.$line;\n}\n\n.dungeon-loot-btn {\n  @include ink.button;\n\n  &--primary { @include ink.button-primary; }\n  &--secondary { /* neutral, same as the base button */ }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
